<div class="title-container">
  <div class="title title-dropdown semibold {{ collapsed ? 'closed' : '' }}" role="filter-toggler">{{ title }}</div>
  <div class="reset-filter reset-filter--hidden" role="reset-filter">{{ __('filters.reset') }}</div>
</div>
